import { Link, useRouteError } from "react-router";

import img from "../assets/images/not-found.svg";
import { ErrorPageWrapper } from "@/components";

const Error = () => {
  const error = useRouteError() as Error & { status: number };
  console.log(error);

  if (error.status === 404) {
    return (
      <ErrorPageWrapper>
        <div>
          <img src={img} alt="not found" />
          <h3>Ohh! page not found</h3>
          <p>We can't seem to find the page you're looking for</p>
          <Link to="/dashboard">back home</Link>
        </div>
      </ErrorPageWrapper>
    );
  }

  return (
    <ErrorPageWrapper>
      <div>
        <h3>something went wrong</h3>
      </div>
    </ErrorPageWrapper>
  );
};

export default Error;
